import './images/bg-1_1.jpg';
import './images/bg-1_2.jpg';
import './images/bg-1_3_1.jpg';
import './images/bg-1_3_2.jpg';
import './images/bg-1_3_3.jpg';
import './images/bg-1_3_4.jpg';
import './images/bg-1_3_5.jpg';
import './images/bg-1_4.jpg';
import './images/index-bg-1-1.jpg';
import './images/index-bg-1-2.jpg';
import './images/index-bg-1-3.jpg';
import './images/index-bg-1-4.jpg';
import './images/cursor-mousewheel.svg';
import './styles/index';

import $ from 'jquery';
import 'fullpage.js';
import '../node_modules/fullpage.js/dist/jquery.fullpage.extensions.min.js';
import Detector from './scripts/vendor/Detector';
import Field from './scripts/three-field';
import Particles from './scripts/three-particles';
import Models from './scripts/three-models'
import Preloader from './scripts/preloader';
import './scripts/canvas-ctrl';
import 'jquery-mousewheel';
import Barba from 'barba.js';
import ChangeBG from './scripts/change-bg';
import {addJqPlugin, animateCss, imgLoaded} from './scripts/helper';
import { $win, $doc, $html, $body, isFirst } from './common'
addJqPlugin('animateCss', animateCss);

const $htmlLang = $html.attr('lang');
const FULLPAGE_SPEED = 700;
let prevSlide;
let prevSection;
let currentSlide;
let currentSection;
let field;
let particles;
let models;
let $particlesCanvas;
let $modelsCanvas;

function indexOn() {
    prevSlide = {1: 0, 2: 0};
    prevSection = 1;
    currentSlide = {1: 0, 2: 0};
    currentSection = 1;
    let $fullpage = $('#fullpage');

    $('.icon-menu, .screen-overlay').on('click', () => {
        if ($body.hasClass('menu-is-active')) {
            $.fn.fullpage.setAllowScrolling(false);
            $.fn.fullpage.setKeyboardScrolling(false);
        } else {
            $.fn.fullpage.setAllowScrolling(true);
            $.fn.fullpage.setKeyboardScrolling(true);
        }
    });

    $win.on('load.barbaView resize.barbaView', function() {
        let width = $win.width();
        let $text = $fullpage.find('.change-page-link_mobile .change-page-link__text');
        let $moreText = '';
        if($htmlLang === 'ru') {
            $moreText = 'Подробнее';
        } else if($htmlLang === 'en') {
            $moreText = 'More';
        }

        if (width < 769) {
            $text.text($moreText);
        }
    });

    function moveControls() {
        let section = currentSection - 1;
        let slide = currentSlide[currentSection];
        let $menu = $('.screen__menu').eq(section);
        let $activemenu = $menu.children('.screen-ctrl-link').eq(slide);
        $menu.children('.screen-ctrl-link').removeClass('is-active');
        $activemenu.addClass('is-active');
        setTimeout(function() {
            // checkAnimation
            let $parent = $('.main__screen').eq(section);
            let $slide = $parent.find('.screen').eq(slide);
            $slide.addClass('animated');
        }, 2100);
    }

    // инициализация three
    if (Detector.webgl) {
        field = new Field('[data-canvas="field"]');
        particles = new Particles('[data-canvas="particles"]');
        models = new Models('[data-canvas="models"]', '[data-canvas-section="models"]');

        $particlesCanvas = $('[data-canvas="particles"]').css({'animation-duration': FULLPAGE_SPEED + 'ms'});
        $modelsCanvas = $('[data-canvas="models"]').css({'animation-duration': FULLPAGE_SPEED + 'ms'});

        $win.on('load.barbaView', function () {
            models.startPreloadModels();
        });

        // переключение моделей
        $('[data-canvas-section="models"]').each((i, el) => {
            $(el).canvasCtrl(models);
        });
    } else {
        $('[data-canvas]').addClass('screen__canvas--no-webgl');
    }

    $fullpage.fullpage({
        controlArrows: true,
        verticalCentered: false,
        anchors: ['0', '1'],
        animateAnchor: false,
        recordHistory: false,
        scrollBar: true,
        menu: '#controls',
        loopHorizontal: false,
        resetSliders: true,
        scrollingSpeed: FULLPAGE_SPEED,
        onLeave(index, nextIndex, direction) {
            prevSection = index;
            currentSection = nextIndex;
            moveControls();
            updateThreeCanvasObjects();
        },
        onSlideLeave (anchorLink, index, slideIndex, direction, nextSlideIndex) {
            prevSection = index; // если движение по горизонтали, то прошлый слайд находится на той же секции, что и текущий слайд
            prevSlide[index] = slideIndex;
            currentSlide[index] = nextSlideIndex;
            moveControls();
            if (index === 2 && slideIndex === 1 && nextSlideIndex === 2) {
                // from ParticleStream to Models
                updateThreeCanvasObjects();
                models.implodeParticlesFromStream(particles.getPositions(), particles.particleCloud.rotation.y, FULLPAGE_SPEED);
                models.waitForRender().then(() => {
                    $modelsCanvas.addClass('is-active');
                    $particlesCanvas.removeClass('is-active');
                });
            } else if (index === 2 && slideIndex === 2 && nextSlideIndex === 1) {
                // from Models to ParticleStream
                models.explodeParticlesToStream(particles.getPositions(), particles.particleCloud.rotation.y, FULLPAGE_SPEED - 25).then(() => {
                    $modelsCanvas.removeClass('is-active');
                    $particlesCanvas.addClass('is-active');
                    updateThreeCanvasObjects();
                });
            } else {
                if (index === 2) {
                    $body.addClass('bg-blue');
                    setTimeout(() => {
                        $body.removeClass('bg-blue');
                    }, FULLPAGE_SPEED);
                    if (slideIndex === 0 && nextSlideIndex === 1) {
                        // come from left to ParticleStream
                        $particlesCanvas.addClass('screen--translate-from-right');
                        setTimeout(() => {
                            $particlesCanvas.removeClass('screen--translate-from-right');
                        }, FULLPAGE_SPEED);
                    } else if (slideIndex === 1 && nextSlideIndex === 0) {
                        // away from ParticleStream to left
                        $particlesCanvas.addClass('screen--translate-to-right');
                        setTimeout(() => {
                            $particlesCanvas.removeClass('screen--translate-to-right');
                        }, FULLPAGE_SPEED);
                    } else if (slideIndex === 2 && nextSlideIndex === 3) {
                        // away from Models to right
                        $modelsCanvas.addClass('screen--translate-to-left');
                        setTimeout(() => {
                            $modelsCanvas.removeClass('screen--translate-to-left');
                        }, FULLPAGE_SPEED);
                    } else if (slideIndex === 3 && nextSlideIndex === 2) {
                        // come from right to Models
                        $modelsCanvas.addClass('screen--translate-from-left');
                        setTimeout(() => {
                            $modelsCanvas.removeClass('screen--translate-from-left');
                        }, FULLPAGE_SPEED);
                    }
                }
                updateThreeCanvasObjects(true);
            }
        },
        afterRender() {
            $doc.trigger('fullpage_loaded');
        },
        afterResize() {
            $win.trigger('fullpage_resized');
        }
    });

    $('.screen-ctrl-link').click(function() {
        let $this = $(this);
        $this.siblings('.screen-ctrl-link').removeClass('is-active');
        $this.addClass('is-active');
    });

    ChangeBG.of($('[data-change-trigger]', '.cards'), $('[data-bg]'));
}
/**
 * возвращает объект канваса, находящийся в указанных секции и слайде
 * @param sectionIndex
 * @param slideIndex
 * @returns {*}
 */
function getThreeCanvasObject(sectionIndex, slideIndex) {
    if (sectionIndex === 2 && slideIndex === 0) {
        return field;
    } else if (sectionIndex === 2 && slideIndex === 1) {
        return particles;
    } else if (sectionIndex === 2 && slideIndex === 2) {
        return models;
    } else {
        return false;
    }
}
/**
 * Останавливаем канвас старолого слайда и запускаем канвас нового
 */
function updateThreeCanvasObjects(isTranslate) {
    if (Detector.webgl) {
        let prevCanvasObject = getThreeCanvasObject(prevSection, prevSlide[prevSection]);
        let currentCanvasObject = getThreeCanvasObject(currentSection, currentSlide[currentSection]);
        if (prevCanvasObject) {
            prevCanvasObject.stop();
        }
        if (currentCanvasObject) {
            currentCanvasObject.play();
        }
        // активация видимости частиц и моделей
        if (isTranslate) {
            if (currentCanvasObject === particles) {
                $particlesCanvas.addClass('is-active');
            }
            if (currentCanvasObject === models) {
                $modelsCanvas.addClass('is-active');
            }
            setTimeout(() => {
                if (prevCanvasObject === particles) {
                    $particlesCanvas.removeClass('is-active');
                }
                if (prevCanvasObject === models) {
                    $modelsCanvas.removeClass('is-active');
                }
            }, FULLPAGE_SPEED)
        }
    }
}
function firstAnimate() {
    $('[data-first-animate]').map((i, el) => {
        const $el = $(el);
        $el.animateCss($el.attr('data-first-animate'), () => {
            $el.attr('data-first-animate', null);
        });
    });
}


if (isFirst) {
    let preloader = new Preloader;
    preloader.start();
    let promiseFullpageLoaded = new Promise(function (resolve) {
        $doc.one('fullpage_loaded', resolve);
    });
    let promiseImgLoaded = imgLoaded($('[data-wait]').attr('data-wait'));
    Promise.all([promiseFullpageLoaded, promiseImgLoaded]).then(() => {
        preloader.finish().then(() => {
            firstAnimate();
            preloader.hide()
        });
    });

    indexOn();
}

const Index = Barba.BaseView.extend({
    namespace: 'index',

    onEnter() {
        //console.log('Новый контейнер готов и прикреплен к dom.')
        $('[data-preloader]').addClass('uk-hidden');
        // хром не успевает применить стили к только что вставленному в дом барба-контейнеру
        setTimeout(indexOn, 0);
        firstAnimate();
    },

    onEnterCompleted() {
        //console.log('Переход закончился.')
    },

    onLeave() {
        //console.log('Новый переход к новой странице только начался.')
        if (Detector.webgl) {
            let currentCanvasObject = getThreeCanvasObject(currentSection, currentSlide[currentSection]);
            if (currentCanvasObject) {
                currentCanvasObject.stop();
            }
        }
        $.fn.fullpage.destroy('all');
        $win.off('.barbaView');
        let section = currentSection - 1;
        let slide = currentSlide[currentSection];
        let $parent = $('.main__screen').eq(section);
        let $slide = $parent.find('.screen').eq(slide);
        $('.screen').css({visibility: 'hidden'});
        $slide.css({position: 'fixed', left: 0, top: 0, visibility: ''});
        $slide.find('[data-animate]').css({opacity: 1});
    },

    onLeaveCompleted() {
        //console.log('Контейнер был удален из dom.')
    },
});

Index.init();


// WEBPACK FOOTER //
// ./index.js